module.exports = __webpack_public_path__ + "static/obj_2@2x-ccaae0c8c5335902f7e8d412cd99faca.png";